import RichText from '@eneco/components/RichText/RichText';
import { Stack } from '@eneco/sparky/components/Stack/Stack.js';
import { EnergyBill } from '@eneco/sparky/illustrations/eneco/EnergyBill.js';
import { useContent } from '@sitecore/common';
import { DashboardOverviewRendering } from '@sitecore/types/DashboardOverview';

import { StyledDashboardBlock } from './DashboardBlock';
import { DashboardLink } from './DashboardLink';

export const MonthlyBillingCard = () => {
  const { fields } = useContent<DashboardOverviewRendering>();

  return (
    <StyledDashboardBlock>
      <Stack direction="row" gap="4" alignY="center">
        <Stack.Item shrink={false}>
          <EnergyBill />
        </Stack.Item>
        <RichText html={fields.monthlyBillingCard?.description.value ?? 'Maandelijkse factuur [not in sitecore]'} />
      </Stack>
      <DashboardLink
        href={fields.monthlyBillingCard?.link.value.href}
        emphasis="high"
        trackingComponentName="monthly_billing_link"
        trackingComponentType="dashboard_link">
        {fields.monthlyBillingCard?.link.value.text ?? 'Ga naar mijn facturen [not in sitecore]'}
      </DashboardLink>
    </StyledDashboardBlock>
  );
};
